module.exports = __webpack_public_path__ + "static/img/vip.6aecd0cf.png";